import * as React from 'react'

import { cn } from '@/lib/utils'

import { Label } from './label'
interface TextareaProps extends React.ComponentProps<'textarea'> {
  label?: string
  supportingText?: string
  error?: boolean
  disabled?: boolean
  maxLength?: number
  value: string
  labelClassName?: string
  inputClassName?: string
}
function Textarea({ className, label, supportingText, maxLength, labelClassName, inputClassName, ...props }: TextareaProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <Label className={labelClassName} htmlFor={props.id}>
          {label}
        </Label>
      )}
      <div className='relative'>
        <textarea
          data-slot='textarea'
          className={cn(
            'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full resize-none rounded-md border bg-transparent px-3 py-2 pb-20 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:bg-[#e9ecef] disabled:opacity-50 md:text-sm',
            maxLength ? 'pb-6' : 'pb-40',
            inputClassName
          )}
          maxLength={maxLength}
          {...props}
        />
        {maxLength && (
          <p className='text-text-placeholder absolute end-2 bottom-2 text-xs'>
            {props.value?.length}/{maxLength}
          </p>
        )}
      </div>
      {supportingText && <p className='text-text-disabled text-start text-xs'>{supportingText}</p>}
    </div>
  )
}

export { Textarea }
